import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Container from '../../../Core/Container';
import Image from '../../../Core/Image';
import MultiColumnLayout from '../MultiColumnLayout';

export const Wrapper = styled.div`
  background-color: ${({ colourOverrideBackground }) =>
    colourOverrideBackground || themeGet('colors.colors.neutral_1')};
  background-image: url(${({ background }) => background});
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  @media only screen and (min-width: ${themeGet(
    'breakpoints.md'
  )}) and (max-width: calc(${themeGet('breakpoints.lg')} - 1px)){
    flex-direction: row;

    > div > div > div{
      width: calc(50% - (18px * 2))
    }
  }
  
`;

export const StyledContainer = styled(Container)`
  padding: 50px 0 60px;

  > h1,
  > h2,
  > h3,
  > h4,
  > h5,
  > h6 {
    text-align: center;
    margin-bottom: 52px;
    color: ${({ focusTextColour }) =>
      focusTextColour || themeGet('colors.text-primary')};
  }

  > h3 {
    font-weight: 700;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    padding: 45px 60px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    padding: 90px;

    h2 {
      font-size: 36px;
      line-height: 38px;
    }
  }

  /* Add class header styles to override sizes when chosen as tags */
  .h2 {
    font-size: 36px;
    line-height: 38px;
  }

  .h3 {
    font-weight: 700;
    line-height: 26px;
  }

  .h4 {
    font-size: 22px;
    line-height: 32px;
  }

  .h5 {
    font-size: 18px;
    line-height: 28px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xl')}) {
    padding: 45px 90px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.max')}) {
    padding: 90px;
  }
`;

export const Columns = styled(MultiColumnLayout)``;

export const Block = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 390px;

  &:hover {
    -webkit-box-shadow: 0px 10px 13px -7px #a5a5a5,
      5px 5px 17px 5px rgba(165, 165, 165, 0);
    box-shadow: 0px 10px 13px -7px #a5a5a5,
      5px 5px 17px 5px rgba(165, 165, 165, 0);
  }
  p {
    margin-bottom: 45px;
  }

  a {
    margin-top: 0px;
  }

  .episodelink {
    width: 100%;
    height: 100%;
    border-bottom: none;
    margin-bottom: -4px;
    max-width: 390px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    h2,
    .h2,
    p {
      max-width: 250px;
    }
  }
`;

export const StyledImage = styled(Image)`
  margin: 0 auto;
  max-width: 390px;
  width: 100%;
  height: 100%;
  border-radius: 5px 5px 0px 0px;
  align-items: center; 
  
  ${Block}.left &, ${Block}.Left & {
    margin: 0;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    margin: 0;

    ${Block}.left &, ${Block}.Left & {
      margin: 0;
    }
  }
`;

export const Content = styled.div`
  height: auto;

  h2:first-child,
  h3:first-child,
  h4:first-child,
  h5:first-child,
  h6:first-child {
    font-weight: ${themeGet('font-weights.bold')};
    color: ${themeGet('colors.text-secondary')};
    text-align: center;

    ${Block}.left &, ${Block}.Left & {
      text-align: left;
    }

    margin-bottom: 30px;
  }
`;

export const Footer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-top: 0px;
  width: 100%;

  a.episode-cta {
    width: 100%;
    border-radius: 0px 0px 5px 5px;
  }

  h3,
  .h3,
  h4,
  .h4 {
    margin-bottom: 0px;
  }

  @media only screen and (min-width: ${themeGet(
    'breakpoints.md'
  )}) and (max-width: calc(${themeGet('breakpoints.lg')} - 1px)){
    flex-direction: unset;
    justify-content: center;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    flex-direction: row;
    margin-top: -1px;
  }
`;
